import { useEffect, useState } from 'react';
import {
  SEGMENT_DEPLOYABLE_NAME,
  SEGMENT_DEPLOYABLE_VERSION,
} from './analytics/constants';
import { SegmentRegistrationAttributes } from 'src/types/window';

type omittedKeys = 'deployableName' | 'deployableVersion' | 'driverFlowName';

const useSegmentRegistrationAttributes = (
  details: Omit<SegmentRegistrationAttributes, omittedKeys>,
  deps: unknown[]
) => {
  const [isAvailable, setIsAvailable] = useState(false);

  useEffect(() => {
    const timeout = setInterval(() => {
      const funcIsAvailable =
        window.nerdwallet?.ui?.setHeaderProps !== undefined;
      if (funcIsAvailable) {
        setIsAvailable(true);
        clearInterval(timeout);
      }
    }, 10);
    return () => clearInterval(timeout);
  }, []);

  useEffect(() => {
    if (window.nerdwallet?.ui?.setHeaderProps === undefined) {
      return;
    }
    window.nerdwallet.ui.setHeaderProps({
      segmentTrackingAttributes: {
        ...details,
        deployableVersion: SEGMENT_DEPLOYABLE_VERSION,
        deployableName: SEGMENT_DEPLOYABLE_NAME,
        driverFlowName: SEGMENT_DEPLOYABLE_NAME,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAvailable, details, ...deps]);
};

export default useSegmentRegistrationAttributes;
